<template>
  <div class="main main-page">
    <div
      v-for="item in list"
      :key="item.MeetingRoomSubTypeId"
      class="item"
      @click="onClassRoomClick(item)"
    >
      <div class="item-header">
        <div class="title">
          {{ item.MeetingRoomSubTypeName }}
        </div>
        <div class="checkMore">
          <img src="@/assets/image/star.png" alt="" />
          查看更多
        </div>
      </div>
      <div class="totalBox">
        <van-row gutter="12">
          <van-col span="6">
            <div class="totalItem yellow-border">
              <p class="name">教室总数</p>
              <p class="value">{{ item.TotalCount }}</p>
            </div>
          </van-col>
          <van-col span="6">
            <div class="totalItem red-border">
              <p class="name">占用数</p>
              <p class="value">{{ item.OccupyCount }}</p>
            </div>
          </van-col>
          <van-col span="6">
            <div class="totalItem yellow-border">
              <p class="name">空闲数</p>
              <p class="value">{{ item.FreeCount }}</p>
            </div>
          </van-col>
          <van-col span="6">
            <div class="totalItem red-border">
              <p class="name">不可使用数</p>
              <p class="value">{{ item.UnavailCount }}</p>
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
  </div>
</template>

<script>
import classRoomApi from "@/api/classRoom";
export default {
  data() {
    return {
      list: []
    };
  },
  mounted() {
    this.fetchOccupancyStatistics();
  },
  created() {
  },
  methods: {
    onClassRoomClick(item) {
      this.$router.push({
        name: "classroomUsageClassroomList",
        query: {
          MeetingRoomTypeId: item.MeetingRoomTypeId,
          MeetingRoomSubTypeId: item.MeetingRoomSubTypeId
        }
      });
    },
    fetchOccupancyStatistics() {
      classRoomApi
        .QueryMeetingRoomOccupancyStatistics({
          FilterAccess: true
        })
        .then(res => {
          this.list = res.Data;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.main {
  padding: 15px;
  .item {
    position: relative;
    padding: 16px;
    border-radius: 7px;
    background-color: rgb(248, 248, 248);
    margin-bottom: 10px;
    .item-header {
      display: flex;
      .checkMore {
        font-size: 12px;
        color: rgb(102, 102, 102);
        font-weight: 600;
      }
      .title {
        font-size: 14px;
        font-weight: bold;
        color: rgb(51, 51, 51);
        margin-bottom: 15px;
        flex: 1;
      }
    }
    .totalBox {
      // display: flex;
      font-weight: 500;
      color: #333;
      .totalItem {
        // width: 22%;
        font-size: 12px;
        background: white;
        // margin-right: 4%;
        text-align: center;
        padding: 11px 0;
        border-radius: 5px;
        .name {
          margin-bottom: 5px;
        }
        .value {
          font-size: 14px;
        }
      }
      .yellow-border {
        border-top: 1px solid rgb(255, 198, 58);
      }
      .red-border {
        border-top: 1px solid rgb(210, 0, 0);
      }
    }
  }
}
</style>
